<template>
    <CustomHeader v-if="!isTabView" :text="$t('vip.title')" />
    <div class="vip-container">
        <div class="subContainer" :style="{padding: isTabView ? '0px 25px 25px' : '70px 25px 25px'}">
            <div class="middle-banner">
                <van-row class="toData">
                    <van-col :span="6">
                        <div class="topCard">
                            <span class="topText">{{ $t('vip.currentLevel') }}</span>
                            <img src="@/assets/themeThree/level_one.png" alt="">
                        </div>
                    </van-col>
                    <van-col :span="10" class="middle-text-container">
                        <div class="middle-header-text">{{ $t('vip.follow') }}<span
                                style="color: #FFA600;font-weight: 700;">{{ ' VIP ' +
                                    dataSet.currentLevel }}</span></div>
                        <div class="middle-header-text">{{ $t('vip.needToBet') }} <span style="color: #fff;">
                                {{ dataSet.nextLevelRecord?.bet_min }}
                            </span> </div>
                    </van-col>
                    <van-col :span="8">
                        <div style="display: flex;flex-direction: column;align-items: flex-end;gap: 5px;">
                            <van-button size="small" class="right-btn"
                                :style="{ background: dataSet.remainRewards == 0 ? '#626262' : 'linear-gradient(0deg,rgba(4, 107, 205, 1) 0%, rgba(45, 155, 241, 1) 100%)' }"
                                @click="VIPClaim">{{
                                    $t('vip.collectEverything') }}</van-button>
                            <van-button size="small" class="right-btn"
                                style="background: linear-gradient(0deg,rgba(242, 147, 16, 1) 0%, rgba(252, 182, 89, 1) 100%);"
                                @click="showHistory">{{
                                    $t('vip.history') }}</van-button>
                        </div>

                    </van-col>
                </van-row>
            </div>
            <p class="table-title">{{ $t('vip.tireList') }}</p>
            <div>
                <div class="tabs">
                    <van-tabs id="vipTabs" :ellipsis="false" v-model:active="active">
                        <van-tab v-for="index in tabList" :title="$t(index.name)" :key="index.id" :name="index.id">
                        </van-tab>
                    </van-tabs>
                </div>

                <VIPTableView :activeNo="dataSet.active" :tableData="dataSet.tabelData"
                    :activeData="dataSet.vipConfigData?.rewardsStatus" :vipRewardInfo="dataSet.VIPRewardsInfo"
                    :nextLevelRecord="dataSet.nextLevelRecord" :nextLevel="dataSet.nextLevel" />
            </div>
            <div class="bottom_text">
                <van-row>
                    <van-col span="24" class="title">
                        <div>{{ $t('vip.vipActivityInstructions') }}</div>
                    </van-col>
                </van-row>
                <div class="line_text" v-for="(item, index) in dataSet.activity_intro" :key="index" v-html="item">
                </div>
            </div>
        </div>
        <!-- <div style="background: red;position: fixed; bottom: 0;background: #626262;width: 100%;justify-content: center; display: flex;padding: 10px;">
        <van-button>{{ $t('Reclamar Recompensa de Upgrade') }}</van-button>

        </div> -->
    </div>
    <VipHistoryPopup ref="historyRef" />
</template>
<script setup lang="ts">
import CustomHeader from '@/themes/themeThree/components/common/customHeader.vue';
import VIPTableView from './vipTableView.vue';
import { computed, ref, watch } from 'vue';
import VipHistoryPopup from './vipHistoryPopup.vue';
import { VipData } from '@/view/vip/supportScript';
import { TAB_LIST_THREE } from '@/view/vip/supportScript';

const progressPercentage = computed(() => 6500 * 100 / 10000);
const active = ref(0);
const historyRef = ref()
const vipConfigData = ref()
const tabList = computed(() => {
    var TabList = [...TAB_LIST_THREE]
    if (props.dataSet.vipConfigData?.rewardsStatus.isDailyReward !== 1) {
        TabList = TAB_LIST_THREE.filter(item => item.id !== 2)
    }
    if (props.dataSet.vipConfigData?.rewardsStatus.isWeeklyRewards !== 1) {
        TabList = TabList.filter(item => item.id !== 3)
    }
    if (props.dataSet.vipConfigData?.rewardsStatus.isMonthlyRewards !== 1) {
        TabList = TabList.filter(item => item.id !== 4)
    }
    return TabList
});
const showHistory = () => {
    historyRef.value.open()
}
const props = defineProps<{
    dataSet: VipData,
    isTabView?: boolean
}>()
const emit = defineEmits(['vIPClaim', 'update:active'])

const VIPClaim = () => {
    emit('vIPClaim')
}
watch(active, (val) => {
    emit('update:active', val)
})

</script>
<style scoped>
.vip-container {
    min-height: 100vh;
    background: #090F1F;
}

.vip-banner {
    position: relative;
}

.vip-banner img {
    width: 100%;
}

.header-text {
    position: absolute;
    top: 45%;
    height: 30%;
    left: 0;
    right: 0;
    color: #FFF;
    font-size: 45px;
    font-weight: bold;
    text-shadow: 0 2px 0 #232833;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
}

.topCard {
    position: relative;
}

.topCard img {
    margin-top: 15px;
    width: 60px;

}

.topText {
    position: absolute;
    background: #fe5353;
    padding: 2px;
    border-radius: 5px;
    bottom: 82%;
    color: #fff;

}

.table-title {
    color: #fff;
    font-size: 18px;
}

.subContainer {
    /* padding: 70px 25px 25px; */
}

.middle-banner {
    border-radius: 10px;
    white-space: nowrap;
}

.toData {
    background: #191e2d;
    padding: 10px 2px 10px 0px;
    border-radius: 10px;
}

.middle-text-container {
    justify-content: center;
    display: flex;
    flex-direction: column;
}

.middle-header-text {
    color: #757881;
    font-size: 15px;
    text-align: left;
    /* padding: 5px 15px; */
}

@media (max-width:450px) {
    .middle-header-text {
        font-size: 13px;
    }

    .right-btn {
        font-size: 11px;
    }

    /* .middle-amount {
        font-size: 30px;
    } */
}

.middle-amount {
    color: #FFEE00;
    font-size: 40px;
    text-align: left;
    font-weight: bold;
    padding: 5px 15px 25px;
}

.claimBtn {
    font-size: 15px;
    background: #fd66b1;
    color: #fff;
    border: .02667rem solid #fd66b1;
    border-radius: 10px;
    padding: 15px 0;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 95%;
    /* font-weight: bold; */
}

.disableBtn {
    background: #2e2759;
    color: #7758a4;
    border: .02667rem solid #493779;
}

.bottomData {
    background-image: linear-gradient(270deg, #211a62, #322145);
    padding: 10px;
    border-radius: 0 0 10px 10px;
}

.bottomData-text {
    font-size: 13px;
    color: #e695e6;
    padding-left: 15px;
}

.right-btn {
    width: 66%;
    border: none;
    color: #fff;
}

.progressCard {
    position: relative;
    margin-top: 10px;
    background: #3e2e4b;
    border-radius: 10px;
    /* border: 2px solid orange; */
    border-left: none;
    border-right: none;
    padding: 15px;
}

.card-top {
    color: #FFCEF4;
    font-size: 13px;
    text-align: center;
    white-space: nowrap;
}

.card-top-right {
    color: #ffcef4;
    font-size: 18px;
    text-align: right;
    white-space: nowrap;
}

.bar {
    position: relative;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 10px;
    height: 8px;
    width: 100%;
    margin: 10px 0;
}

.progress {
    background: #ffa600;
    border-radius: 10px;
    height: 8px;
}

.progress-end-dot {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    z-index: 2;
}

.cur-frame {
    height: 0.62rem;
    background: #DD7A33;
    border-radius: 0.34rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 5px 0;
}

.card-top-bottom {
    color: #F8E400;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
}

.card-top-bottom-right {
    color: #ffffffd9;
    font-size: 12px;
    text-align: right;
    white-space: nowrap;
}

.bettingVolume {
    padding: 10px;
    border-radius: 15px;
    margin-top: 10px;
}

.tabs {
    margin-top: -10px;
    position: sticky;
    top: 60px;
    z-index: 10;
    background: #090F1F;
    padding: 10px 0px;
}

.activity-text {
    color: #f9c48680;
    text-align: left;
    white-space: pre-wrap;
    font-size: 14px;
    padding-bottom: 20px;
}

.activity-title-row {
    display: flex;
    align-items: center;
    margin: 30px 0px 20px;
}

.left-img {
    background-image: linear-gradient(90deg, rgba(249, 196, 134, 0.00) 0%, rgba(249, 196, 134, 0.50) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-right: 0.2rem;
}

.activity-title {
    color: #f9c48680;
    font-size: 15px;
    display: flex;
    justify-content: center
}

.right-img {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(249, 196, 134, 0.00) 0%, rgba(249, 196, 134, 0.50) 100%);
    border-radius: 1px;
    width: 5rem;
    height: 2px;
    margin-left: 0.2rem;
}

.bottom_text {
    padding: 30px 0px 0;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: #6b6f79;
    font-weight: bold;
    font-size: 15px;
    padding: 10px 0;
}

.line_text {
    color: #6b6f79;
    font-size: 13px;
    padding: 5px;
}




.cur-frame-point {
    width: 0.62rem;
    height: 0.62rem;
    background: #FFFFFF;
    border-radius: 0.34rem;
}

::v-deep #vipTabs .van-tabs__nav {
    overflow-x: auto !important;
    white-space: nowrap !important;
}

::v-deep #vipTabs .van-tab__text {
    white-space: nowrap !important;
    overflow: visible !important;
    text-overflow: unset !important;
}

::v-deep #vipTabs {
    --van-tabs-nav-background: transparent !important;

}

::v-deep #vipTabs .van-tab--active {
    position: relative;
    --van-tab-active-text-color: #fff !important;
}

::v-deep #vipTabs .van-tab--active::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(0deg, rgba(10, 114, 210, 1), rgba(47, 157, 242, 1));
}

::v-deep #vipTabs .van-tab {
    --van-tab-text-color: #6d788d !important;
    /* font-weight: bold; */
    padding-right: 20px;
}

::v-deep #vipTabs .van-tabs__line {
    display: none;
}
</style>